import { isWeb, useBrowser, useGetListLocalizationWithPaginationQuery } from "@stepapp/core";

import type { LocalizationModelItems } from "@stepapp/core/apiTypes";
import React from "react";
import { useWindowDimensions } from "react-native";
import { useBreakpoints } from "../hooks/useBreakpoints";
import { palette } from "../styles";
import Block from "./Block";
import Button from "./Button";
import LinePlaceholder from "./LinePlaceholder";

type Props = {
  onPress: (localization: LocalizationModelItems) => void;
  t: ToDo;
  link: string;
};

const CitySelector = ({ onPress, t, link }: Props) => {
  const openProposeCity = useBrowser(link);
  const { md } = useBreakpoints();
  const { width: screenWidth } = useWindowDimensions();

  const { data: supportedCities, loading } = useGetListLocalizationWithPaginationQuery({
    variables: { limit: 20, page: 1 },
  });

  const width = md ? 67.5 : (screenWidth - 40) / 8;

  const showLoader = loading && !supportedCities;

  return (
    <Block>
      <Block alignEnd paddingBottom={1}>
        <Button
          label={t("screens.dashboard.proposeCity")}
          onPress={openProposeCity}
          textStyle={{ color: palette.primary.accent }}
          type="link"
        />
      </Block>

      {showLoader && (
        <LinePlaceholder
          borderRadius={2.5}
          height={6}
          width={width}
          marginVertical={isWeb ? 1 : 0}
        />
      )}

      {supportedCities?.listLocalizationWithPagination.items.map((localization) => (
        <Block key={localization?.id} marginVertical={isWeb ? 1 : 0}>
          <Button
            label={localization?.name || ""}
            onPress={() =>
              onPress({
                name: localization?.name || "",
                id: localization?.id || "",
                timezone: localization.timezone || "",
              })
            }
            type="secondary"
          />
        </Block>
      ))}
    </Block>
  );
};

export default React.memo(CitySelector);
